const schema = localStorage.getItem("schema")
export const basicFormData = () => ({
  inputData: {
    intake_no: "",
    is_repairable: false,
    technician_id:"",
    inspected_by: "",
    inspected_at: new Date(),
    received_by: "",
    inspected_remark: "",
    scrap_remark: "",
    is_active: true
  }
});

export const createPageData = () => {
  const payload = {
    modelName: "material_intakes",
    schema:schema,
    "include": [
      { "model": "material_masters", "as": "material" },
      { "model": "client_masters", "as": "customer" },
      { "model": "user_masters", "as": "received_by_user" },
      { "model": "user_masters", "as": "inspected_by_user" }
    ]
  };


  const headerName = "Material Approval";

  const validationType = "MaterialApproval";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  
  return {
    payload,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};


export const exportPageData = {
  modelName: "material_intakes",
  schema: schema,
  "include": [
    { "model": "material_masters", "as": "material" },
    { "model": "client_masters", "as": "customer" },
    { "model": "user_masters", "as": "received_by_user" },
    { "model": "user_masters", "as": "inspected_by_user" }
  ],
  pagination: { page: 1, pageSize: 10000 },
};
